module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/a-le-coq.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["TVC"],"frontmatter":{"date":"August 30, 2026","title":"A. Le Coq ","videoUrl":"https://vimeo.com/899158259?share=copy&fl=sv&fe=ci","image":"/img/alekokk.jpg","credits":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/a-le-coq.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-a-le-coq.json
// module id = 628
// module chunks = 44353235307851